import React, { useState } from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas }     from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
library.add(fas)

import Card          from "@react/shared/ui/Card"
import ChartPanel     from "./components/ChartPanel"
import PositionsPanel from "./components/PositionsPanel"

const TabButton = ({ active, onClick, icon, label }) => (
  <button
    type      = "button"
    onClick   = {onClick}
    className = {`inline-flex items-center gap-2 h-9 px-3 rounded-md text-[13px] font-medium transition ${
      active
        ? "bg-brand-500 text-white"
        : "bg-white text-slate-600 hover:text-slate-900"
    }`}
  >
    <FontAwesomeIcon icon={icon} className="text-[12px]" />
    {label}
  </button>
)

const App = ({ chartNodes, positions, canManage, initialTab, routes }) => {
  const [tab, setTab] = useState(initialTab || "chart")

  return (
    <div className="font-sans bg-slate-50 min-h-screen text-slate-900">
      <div className="px-8 py-8">

        <div className="flex items-start justify-between gap-6 mb-6">
          <h1 className="text-2xl font-semibold text-slate-900">
            {I18n.t("organigram.title")}
          </h1>

          {canManage && (
            <div className="inline-flex items-center bg-white rounded-md border border-slate-200 p-1 gap-1">
              <TabButton
                active  = {tab === "chart"}
                onClick = {() => setTab("chart")}
                icon    = "sitemap"
                label   = {I18n.t("organigram.chart_view")}
              />
              <TabButton
                active  = {tab === "positions"}
                onClick = {() => setTab("positions")}
                icon    = "cog"
                label   = {I18n.t("organigram.positions_management")}
              />
            </div>
          )}
        </div>

        <Card className="rounded-lg">
          {tab === "chart" ? (
            <ChartPanel chartNodes={chartNodes} showHint={canManage} userPath={routes.userPath} />
          ) : (
            <PositionsPanel
              initialPositions={positions}
              routes={{ organigram_positions: routes.organigramPositions }}
            />
          )}
        </Card>

      </div>
    </div>
  )
}

export default App
